import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import { useTranslation } from "react-i18next";

import { useDeleteRuleRulesIdDeleteMutation } from "api";

type DeleteRuleDialogProps = {
  ruleId: string | null;
  onClose: () => void;
};

export function DeleteRuleDialog({ ruleId, onClose }: DeleteRuleDialogProps) {
  const { t } = useTranslation();

  const [deleteRule] = useDeleteRuleRulesIdDeleteMutation();

  return (
    <Dialog open={!!ruleId} onClose={onClose}>
      <DialogTitle>{t("delete_rule")}</DialogTitle>
      <DialogContent dividers>
        {t("are_you_sure_you_want_to_delete_this_rule")}
      </DialogContent>
      <DialogActions>
        <Button variant={"text"} onClick={onClose}>
          {t("Cancel")}
        </Button>
        <Button
          color={"error"}
          onClick={async () => {
            if (ruleId) {
              await deleteRule({
                id: ruleId,
              });
            }

            onClose();
          }}
        >
          {t("ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
